import { Reveal } from "../motion/Reveal";

export const PhotoBreak = ({ image, quote }) => (
  <section data-testid="photo-break" className="relative h-[55vh] overflow-hidden bg-ink-900 sm:h-[65vh] lg:h-[75vh]">
    {image && (
      <img
        src={image}
        alt="Yalı Yurt yaşam alanı"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
    )}
    <div className="absolute inset-0 bg-ink-950/45" />
    <div className="container-x relative flex h-full items-center justify-center">
      <Reveal>
        <p className="max-w-3xl text-center text-2xl font-bold leading-snug tracking-tight text-cream-50 sm:text-3xl lg:text-4xl">
          “{quote}”
        </p>
      </Reveal>
    </div>
  </section>
);
